import terminalService from '../../api/terminal'

// let cacheEmployee = null

export default {

  // Reset employeeCache
  // resetEmployeeCache() {
  //   cacheEmployee = null;
  // },

  /**
   * Get list of products
   * @param {*} params
   * @param {*} params.limit
   * @param {*} params.offset
   * @param {*} params.search
   * @param {*} params.local Add LocalData to products
   */
  async getAll(params) {
    // console.log('options', noCache, params, cacheEmployee)
    // if (noCache) {

    //   return terminalService.Api().get('employee', { params })
    //     .then((response) => {
    //       console.log('response employee', response)
    //       return response.data
    //     })
    //     .catch((error) => { throw error })
    // }
    // if (cacheEmployee) {
    //   return cacheEmployee
    // }
    return terminalService.Api().get('employee', { params })
      .then(response => {
        // cacheEmployee = response.data
        return response.data
      })
      .catch((error) => { throw error })
  },

  async getEmployeeStatus(id, params) {
    return terminalService.Api().get(`employee/${id}`, { params })
      .then(response => {
        return response.data
      })
      .catch((error) => { throw error })
  },

  /**
   * Get specific product
   * @param {*} id
   * @param {*} params
   * @param {*} params.local Add LocalData to product
   */
  getById(id, params = {}) {
    return terminalService.Api().get(`employee/${id}`, { params })
      .then(response => response.data)
      .catch((error) => { throw error })
  },

  /**
   * Get specific employee with pin
   * @param {*} id
   * @param {*} params
   * @param {*} params.local Add LocalData to product
   */
  checkPinCode(id, data) {
    return terminalService.Api().post(`employee/${id}/checkPin`, data)
      .then(response => response.data)
      .catch((error) => { throw error })
  },
  /**
   * Get specific product
   * @param {*} id
   * @param {*} params
   * @param {*} params.local Add LocalData to product
   */
  getByPermission(stringId, params = {}) {
    return terminalService.Api().get(`employee/allowedTo/${stringId}`, { params })
      .then(response => response.data)
      .catch((error) => { throw error })
  },
  /**
   * Create a product. Will also initiate location data
   * @param {*} data
   */
  create(data) {
    return terminalService.Api().post('employee', data)
      .then(response => response.data)
      .catch((error) => { throw error })
  },
  /**
   * Update specific product
   * @param {*} id
   * @param {*} data
   */
  update(id, data) {
    return terminalService.Api().put(`employee/${id}`, data)
      .then(response => response.data)
      .catch((error) => { throw error })
  },
  /**
   * Delete product
   * @param {} id
   * @param {*} params
   */
  delete(id, params) {
    return terminalService.Api().delete(`employee/${id}`, { params })
      .then(response => response.data)
      .catch((error) => { throw error })
  },
  Roles: {
    /**
     * Get list of roles
     * @param {*} params
     * @param {*} params.limit
     * @param {*} params.offset
     * @param {*} params.search
     */
    getAll(params) {
      return terminalService.Api().get('employee/roles', { params })
        .then(response => response.data)
        .catch((error) => { throw error })
    },
    /**
     * Get specific roles
     * @param {*} id
     * @param {*} params
     */
    getById(id, params = {}) {
      return terminalService.Api().get(`employee/roles/${id}`, { params })
        .then(response => response.data)
        .catch((error) => { throw error })
    },
  },
}
